import { DefaultDateFormat } from "framework/utils/date/DefaultDateFormat";
import { formatDateX } from "framework/utils/date/formatDateX";
import { getFormat } from "./getFormat";

export const formatReservationPeriod = (from: Date, to: Date) =>
    `${formatDateX(from, getFormat(from, to))}-${formatDateX(to, DefaultDateFormat)}`;
